import './ProductTable.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

import Loader from '@/ebat/components/blocks/ScanSelfService/SearchInput/AutosuggestionsPanel/ProductsTable/Loader/Loader';
import {
  ProductTableDefaultProps,
  ProductTablePropTypes,
} from '@/ebat/components/blocks/ScanSelfService/SearchInput/AutosuggestionsPanel/ProductsTable/ProductTable.proptypes';
import TableRow from '@/ebat/components/blocks/ScanSelfService/SearchInput/AutosuggestionsPanel/ProductsTable/TableRow/TableRow';
import { useScanSelfServiceAutosuggestionsContext } from '@/ebat/contexts/ScanSelfServiceContext/ScanSelfServiceAutosuggestionsContext';
import { useScanSelfServiceContext } from '@/ebat/contexts/ScanSelfServiceContext/ScanSelfServiceContext';

const snakeToKebabCase = (str) => str.replace('_', '-');

const ProductTable = ({ maxHeight }) => {
  const { t } = useTranslation();
  const { setProduct } = useScanSelfServiceContext();
  const { products, isLoading } = useScanSelfServiceAutosuggestionsContext();
  const columnsType = ['name', 'sku', 'manufacturer_sku'];

  return (
    <div
      className="scan-self-service-table"
      style={{ maxHeight }}
      data-qa-id="scan-self-service-table"
    >
      {products.length > 0 && (
        <TableRow
          isHeader
          columns={columnsType.map((type) => ({
            label: t(
              `ebat:entities:scan_self_service.autosuggestion-table.${snakeToKebabCase(
                type,
              )}`,
            ),
            type: snakeToKebabCase(type),
          }))}
        />
      )}
      <div
        className="scan-self-service-table__body"
        data-qa-id="scan-self-service-table-body"
      >
        {products.map((product) => (
          <TableRow
            key={product.id}
            columns={columnsType.map((type) => ({
              label: product?.[type],
              type: snakeToKebabCase(type),
            }))}
            onSelect={() => setProduct(product)}
          />
        ))}
      </div>
      {isLoading && <Loader className="scan-self-service-table__loader" />}
    </div>
  );
};

ProductTable.defaultProps = {
  ...ProductTableDefaultProps,
};

ProductTable.propTypes = {
  ...ProductTablePropTypes,
};

export default ProductTable;
